import { NumericValueOfNotAvailable } from './constants';

export const hasCouponApplied = (price) => {
  const { isCouponApplied, coupon } = price;
  return isCouponApplied && !!coupon;
};

export const hasFreeQuantityDiscount = (price) => {
  const { isCouponApplied, coupon, freeQuantityRatio } = price;
  return isCouponApplied && !!coupon && coupon.isItemLevel && freeQuantityRatio > 0;
};

export const hasItemPriceDiscount = (price) => {
  const { isCouponApplied, coupon, freeQuantityRatio } = price;
  return isCouponApplied && !!coupon && coupon.isItemLevel && freeQuantityRatio === 0;
};

export const getFreeQuantity = (price, quantity) => {
  return hasFreeQuantityDiscount(price) ? Math.floor(quantity * price.freeQuantityRatio) : 0;
};

/*
 * Note:
 *   The following legacy APIs are only applicable for calculating prices based on the price table!
 *
 *   Currently, all APL internal brands have been upgraded to calculate prices based on the shopping cart
 *   and by calling the Pricing Service, while third-party brands still calculate prices based on the price table.
 *   So please be careful when using these APIs, and be sure to distinguish between specific situations.
 */
const getPriceRowByQuantity = (price, quantity) => {
  if (!price || !price.priceTable || price.priceTable.length === 0) return undefined;
  const rows = price.priceTable.filter((row) => row.quantity <= quantity);
  return rows.length > 0 ? rows[rows.length - 1] : price.priceTable[0];
};

export const isUnitPriceNotAvailable = (price, quantity) => {
  const priceRow = getPriceRowByQuantity(price, quantity);
  return !priceRow || priceRow.unitPriceIsNotAvailable;
};

export const getDiscount = (price, quantity) => {
  if (isUnitPriceNotAvailable(price, quantity)) return NumericValueOfNotAvailable;
  if (!hasItemPriceDiscount(price)) return 0;

  const priceRow = getPriceRowByQuantity(price, quantity);
  const { discountedUnitPrice, unitPrice } = priceRow;
  return (unitPrice - discountedUnitPrice) * quantity;
};

export const getSellUnitPriceByQuantity = (price, quantity) => {
  const { hasNavInkDiscount, isClearance, isEveryDayLowPrice } = price;
  const priceRow = getPriceRowByQuantity(price, quantity);
  return isUnitPriceNotAvailable(price, quantity)
    ? NumericValueOfNotAvailable
    : hasItemPriceDiscount(price) || hasNavInkDiscount || isClearance || isEveryDayLowPrice
    ? priceRow.discountedUnitPrice
    : priceRow.unitPrice;
};
/*************************************************** Note End ***************************************************/
